/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {Component, Inject, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";

import {RegistDialogComponent} from "../../../platform/auth/regist-dialog/regist-dialog.component";

import {AigiaAuth2Service} from "../aigia-auth2.service";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthLevel, Callback, IErrorObject} from "../../../../../types/platform/universe";
import {TranslateService} from "@ngx-translate/core";
import {MessageDialogComponent} from "../../base/components/message-dialog/message-dialog.component";
import {Guests2Service} from "../../guests2/guests2.service";

/**
 *
 *
 * @since 0.01
 */
@Component({
	selector: "aigia-regist-dialog2",
	styleUrls: ["../aigia-auth.component.css"],
	templateUrl: "./aigia-regist-dialog2.component.html",
})
export class AigiaRegistDialog2Component extends RegistDialogComponent implements OnInit {

	public all_studios: { user_id: string, username: string, nickname: string }[] = [];
	private selected_studio: { user_id: string, username: string, nickname: string } = null;

	/**
	 * @constructor
	 * @param data
	 * @param matDialogRef
	 * @param accountService
	 * @param snackbar
	 * @param auth
	 * @param router
	 * @param translate
	 */
	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: any,
		public matDialogRef: MatDialogRef<AigiaRegistDialog2Component>,
		private accountService: Guests2Service,
		public snackbar: MatSnackBar,
		private matDialog: MatDialog,
		public auth: AigiaAuth2Service,
		private route: ActivatedRoute,
		protected router: Router,
		public translate: TranslateService
	) {
		super(data, matDialogRef, snackbar, auth, router);
	}

	/*
	* todo
	 */
	public toNickname(): void {
		const names: string[] | null = this.content.username.split("@");
		if (names) {
			if (names.length > 0) {
				this.content.nickname = names[0];
			}
		}
	}

	/*
	* todo
 	*/
	private errorDialog(error: IErrorObject, callback: (result: any) => void = (error: IErrorObject) => {
	}): void {
		if (error) {
			if (error.code === 1) {
				this.router.navigate(['/']);
			} else {
				const dialog: MatDialogRef<any> = this.matDialog.open(MessageDialogComponent, {
					width: "30%",
					minWidth: "320px",
					height: "fit-content",
					data: {content: {title: "Error.", message: this.translate.instant(error.message), tag: error.tag}},
					disableClose: true,
				});

				dialog.afterClosed().subscribe((result: any): void => {
					callback(result);
				});
			}
		}
	}

	/**
	 * @returns Promise
	 */
	private async sha256(text: string): Promise<string> {
		const uint8 = new TextEncoder().encode(text)
		const digest = await crypto.subtle.digest('SHA-256', uint8)
		return Array.from(new Uint8Array(digest)).map(v => v.toString(16).padStart(2, '0')).join('');
	}

	/**
	 * @returns none
	 */
	private HashValue(S: string, length: number, callback: Callback<string>): void {
		this.sha256(S).then((hash): void => {
			callback(null, hash.slice(0, length));
		}).catch((error): void => {
			callback(error, null);
		});
	}

	/**
	 *
	 * @param hash
	 * @param plain
	 * @param callback
	 */
	private hashEqual(hash: string, plain: string, callback: Callback<boolean>): void {
		this.HashValue(plain, 10, (error, hashed_target) => {
			callback(error, (hashed_target === hash));
		});
	}

	/**
	 * @returns none
	 */
	private nameEqual(accounts: any[], hashed_name: string, callback: Callback<any>): void {
		accounts.forEach((account: { user_id: any, username: string, nickname: string }) => {
			if (account.username) {
				this.hashEqual(hashed_name, account.username, (error: any, match: boolean) => {
					if (!error) {
						if (match) {
							callback(null, account);
						} else {
							callback(null, null);
						}
					} else {
						callback(error, null);
					}
				})
			}
		});
	}

	/**
	 * @returns none
	 *
	 * URLに設定があればフィルタリング。
	 * なければ全て。
	 */
	private hashFilter(source: any, hashed_name: string, callback: Callback<any>): void {
		let result = source;
		if (hashed_name) {
			this.nameEqual(source, hashed_name, (error: IErrorObject, equals: any) => {
				if (!error) {
					if (equals) {
						result = [equals];
						callback(null, result);
					}
				} else {
					callback(error, null);
				}
			});
		} else {
			callback(null, result);
		}
	}

	public hash_to_account(hash: string, type: string, callback: (error: IErrorObject, account: any) => void) {

	}

	/**
	 * todo
	 */
	public ngOnInit() {
		super.ngOnInit();
		const option = {sort: {}, skip: 0, limit: 0};
		this.accountService.brief_account({type: "studio"}, option, (error: IErrorObject, all_studios: any[]): void => {
			if (!error) {
				if (all_studios) {
					if (Array.isArray(all_studios)) {
						this.all_studios = all_studios;
					}
				}
				this.route.queryParams.subscribe(params => {
					if (params.s) {
						this.hashFilter(all_studios, decodeURIComponent(params.s), (error: IErrorObject, selected_studios: any[]): void => {
							if (!error) {
								if (selected_studios) {
									if (Array.isArray(selected_studios)) {
										if (selected_studios.length > 0) {
											this.selected_studio = selected_studios[0];
										}
									}
								}
							} else {
								this.errorDialog(error);
							}
						});
					}
				});
			} else {
				this.errorDialog(error);
			}
		});
	}

	/**
	 * todo
	 */
	public get studioName(): string {
		let result: string = "";
		if (this.selected_studio) {
			result = this.selected_studio.nickname;
		}
		return result;
	}

	public onChangeStudio(event: any): void {
		this.selected_studio = event.value;
	}

	/**
	 * todo
	 */
	public onAccept(): void {
		this.Progress(true);
		const category: string = "";
		const type: string = "";
		const auth: number = AuthLevel.user;
		let parent: string = "";
		if (this.selected_studio) {
			parent = this.selected_studio.user_id;
		}
		const metadata: any = {nickname: this.content.nickname, id: this.content.params, parent: parent};
		this.auth.regist(auth, this.content.username, this.content.password, category, type, metadata, (error: IErrorObject, result: any) => {
			if (!error) {
				this.matDialogRef.close(this.data);
			} else {
				this.errorDialog(error);
			}
			this.Progress(false);
		});
	}
}
